<!-- Discrète, à plat : une proposition, pas une alerte. Absente quand rien ne semble fini. -->
@if (shown.length) {
  <section class="mb-6 flex items-center gap-3 rounded-card border border-vw-line bg-vw-surface p-4" data-test="finished-card">
    <ng-container *ngTemplateOutlet="thumb; context: { $implicit: shown[0] }" />
    <p class="min-w-0 flex-1 text-body font-semibold text-vw-ink">{{ 'home.finished.card.title' | vwPlural: shown.length }}</p>
    <vw-button look="secondary" customClass="shrink-0" [label]="'home.finished.card.cta' | vwPlural: shown.length"
      (onClick)="openSheet()"></vw-button>
  </section>
}

<vw-toast-popup [isOpen]="sheetOpen" [title]="'home.finished.sheet.title' | translate"
  [subtitle]="'home.finished.sheet.subtitle' | translate" (close)="sheetOpen = false">
  <div class="flex flex-col px-4 pb-8">
    <ul class="divide-y divide-vw-line">
      @for (plant of shown; track plant.uid) {
        <li class="flex items-center gap-3 py-3" data-test="finished-row">
          <ng-container *ngTemplateOutlet="thumb; context: { $implicit: plant }" />
          <span class="min-w-0 flex-1">
            <!-- Ni le nom ni la zone ne se coupent : le nom tient sur deux lignes,
                 la raison et la zone passent à la ligne au besoin. -->
            <span class="line-clamp-2 break-words text-body font-semibold text-vw-ink" data-test="finished-name">
              {{ plant.cultivationName }}
              @if (plant.variantName && plant.variantName !== plant.cultivationName) {
                <span class="font-normal text-vw-muted">{{ plant.variantName }}</span>
              }
            </span>
            <span class="block break-words text-body-s text-vw-body" data-test="finished-reason">
              {{ reasonOf(plant).key | translate: reasonOf(plant).params }}@if (plant.locationName) {<span class="text-vw-muted">, {{ plant.locationName | locationLabel }}</span>}
            </span>
            <button type="button" (click)="stillGrowing(plant)" data-test="finished-still-growing"
              class="min-h-target text-body-s font-semibold text-vw-primary">
              {{ 'home.finished.still-growing' | translate }}
            </button>
          </span>
          <vw-button look="secondary" customClass="shrink-0" label="home.finished.tidy" data-test="finished-tidy"
            [ariaLabel]="'home.finished.tidy-label' | translate: { plant: plant.cultivationName }"
            (onClick)="tidy(plant)"></vw-button>
        </li>
      }
    </ul>
    @if (shown.length > 1) {
      <vw-button look="primary" customClass="mt-4 w-full" label="home.finished.tidy-all" data-test="finished-tidy-all"
        (onClick)="tidyAll()"></vw-button>
    }
  </div>
</vw-toast-popup>

@if (pendingUndo; as undo) {
  <vw-undo-snackbar [key]="undo.key" [message]="undo.message | vwPlural: undo.count ?? 1" [overSheet]="sheetOpen"
    (undo)="onUndo($event)" (closed)="onUndoClosed($event)"></vw-undo-snackbar>
}

<!-- La photo de la culture, ou une feuille d'automne quand elle n'en a pas. -->
<ng-template #thumb let-plant>
  @if (plant.imageUrl) {
    <img [src]="plant.imageUrl" alt="" class="vw-plant-thumb">
  } @else {
    <div class="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-vw-surface-tint text-title-m" aria-hidden="true">🍂</div>
  }
</ng-template>
